import axios from 'axios';
import config from '@/config';
import { getCookie, removeCookie } from '@/utils/cookie';
import notification from 'ant-design-vue/es/notification';

const API_BASE_URL = config.apiBaseUrl;

const API = axios.create({
  baseURL: API_BASE_URL
});

export const apiBase = options => {
  return new Promise((resolve, reject) => {
    API(options)
      .then(response => {
        resolve(response.data);
      })
      .catch(errors => {
        reject(errors);
      });
  });
};

const err = (error) => {
  const { response } = error;
  if (response) {
    const { data } = response;
    switch (response.status) {
      case 401:
        removeCookie('userInfo');
        removeCookie('token');
        break;
      case 403:
        notification.error({
          message: 'Forbidden',
          description: data.message
        });
        break;
      case 500:
        notification.error({
          message: 'Internal Error',
          description: data.message.includes('SQLSTATE') ? 'There is an error with database' : data.message
        });
        break;
    }
  }
  return Promise.reject(error);
};

API.interceptors.request.use(
  function(config) {
    const TOKEN = getCookie('token');
    // const { email: EMAIL } = JSON.parse(getCookie('userInfo') || '{}') || null;
    return {
      ...config,
      headers: {
        ...config.headers,
        ...(TOKEN && { Authorization: `Bearer ${TOKEN}` }),
        // ...(EMAIL && { 'X-Authorization-Email': EMAIL })
      }
    };
  },
  err
);

API.interceptors.response.use(
  function(response) {
    return response;
  },
  err
);
